import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useFormFields } from '../../../libs/hooksLib';
import { isNilOrEmpty } from '../../../utils/objectUtils';
import { Auth } from 'aws-amplify';
import { onError } from '../../../libs/errorLib';

const useResetPassword = () => {
    const history = useHistory();
    const [fields, handleFieldChange] = useFormFields({
        code: '',
        email: '',
        password: '',
        confirmPassword: '',
    });
    const [isSendingCode, setIsSendingCode] = useState(false);

    function validateCodeForm() {
        return !isNilOrEmpty(fields.email);
    }

    const handleSendCodeClick = async (
        event: React.MouseEvent<HTMLButtonElement>
    ) => {
        event.preventDefault();

        setIsSendingCode(true);

        try {
            await Auth.forgotPassword(fields.email);
            history.push('/login/resetConfirmation');
        } catch (error) {
            onError(error);
            setIsSendingCode(false);
        }
    };
    return {
        fields,
        handleFieldChange,
        isSendingCode,
        handleSendCodeClick,
        validateCodeForm,
    };
};

export default useResetPassword;
